var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B6B89",
    d: "M16 10v3.006A1.995 1.995 0 0 1 14.006 15H3.01a1.995 1.995 0 0 1-1.994-1.994V10h1v3.006c0 .548.445.994.994.994h10.996a.995.995 0 0 0 .994-.994V10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B6B89",
    d: "M10.85 3.394 9 1.451v8.559c0 .307-.224.555-.5.555s-.5-.248-.5-.555V1.483L6.18 3.394a.52.52 0 0 1-.77 0 .617.617 0 0 1 0-.829L7.36.515a1.55 1.55 0 0 1 2.31 0l1.95 2.05c.214.229.214.601 0 .83a.52.52 0 0 1-.77 0"
  })));
};
export default SvgUpload;